export default __webpack_public_path__ + "static/media/instituto cvt.3c96f6f5.jpeg";